import { render, staticRenderFns } from "./new-loan-request-modal.vue?vue&type=template&id=088dbc3b&"
import script from "./new-loan-request-modal.vue?vue&type=script&lang=ts&"
export * from "./new-loan-request-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports